import styles from './FileUploadHistoryRules.module.css'

function FileUploadHistoryRules() {
  return (
    <div>
      <div className={styles.rules_container}>
        <strong>Combo History file rules:</strong>
        <ol>
          <li>The file content must be comma-separate and in .csv format.</li>
          <li>
            Columns / Headers: <pre>NRIC / MSISDN, Channel, Order Date</pre>
            <pre
              style={{
                fontSize: '10px',
                backgroundColor: '#dae6f6ff',
                padding: '2px'
              }}
            >
              Note: Date format should be DD-MMM-YY (e.g. 30-Oct-25)
            </pre>
          </li>
          <li>Only one MSISDN or NRIC value per line.</li>
          <li>All 3 fields are mandatory.</li>
        </ol>
      </div>
      <div className={styles.rules_container}>
        <strong>Sample file content:</strong>
        <pre className={styles.sample_data_container}>
          NRIC / MSISDN, Channel, Order Date
          <br />
          601136759823,MSA,30-Oct-25
          <br />
          601137127588,MSA,9-Jul-23
        </pre>
      </div>
    </div>
  )
}

export default FileUploadHistoryRules
